import React, { useState, useEffect } from "react";
import {
  TextField,
  InputAdornment,
} from "@material-ui/core";


export default function CreditPercentField(
	{
    fieldConfig,
    currentMetafields,
    hideChannels = false,
    channelDisplayNames,
    setMetafieldsValues
	}) {

  const [value, setValue] = useState(null);

  useEffect(() => {
		const externalValue = 
          currentMetafields[0].meta_value_numeric || currentMetafields[0].meta_value_numeric===0
            ? currentMetafields[0].meta_value_numeric
            : ""
        ;
    if (externalValue !== value) {
      setValue(externalValue);
    }
  }, [currentMetafields]);

  useEffect(() => {
    if (value !== null) {
      const externalValue = 
          currentMetafields[0].meta_value_numeric || currentMetafields[0].meta_value_numeric===0
            ? currentMetafields[0].meta_value_numeric
            : ""
        ;
      if (externalValue !== value)
        setMetafieldsValues(currentMetafields, value);
    }
  }, [value]);
  
	if (!fieldConfig )
		return null;	
	
  const helperText = hideChannels
			? null
			: ( currentMetafields.map((metafield, i) => channelDisplayNames[metafield.channel] + (i < currentMetafields.length - 1 ? ", " : "")) );
	
  const inputProps = {};
  inputProps.style = { textAlign: "right" };
      
  if (fieldConfig.hasOwnProperty("min") && !isNaN(fieldConfig.min))
    inputProps.min = parseFloat(fieldConfig.min);
  if (fieldConfig.hasOwnProperty("max") && !isNaN(fieldConfig.max))
    inputProps.max = parseFloat(fieldConfig.max);
  if (fieldConfig.step && !isNaN(fieldConfig.step))
    inputProps.step = parseFloat(fieldConfig.step);
  
  return (
    <TextField
      key={currentMetafields[0].id}
      label={fieldConfig.label}
      type="number"
      helperText={helperText}
      value={value ? value : ""}
      onChange={(e) => {
        setValue(e.target.value);
      }}
      onBlur={() => {
        // force rerender to make sure placeholders using the value of this field are updated
        setMetafieldsValues(currentMetafields, value, true);
      }}
      InputProps={{
        endAdornment: <InputAdornment position="end">%</InputAdornment>,
      }}
      inputProps={inputProps}
      style={{width:150}}
    />
	);
}
